/** The Daily Dig's words (docs/spec/07 §2): the day's title and the line players share. Pure. */

import type { BoardEntry } from '../../platform/leaderboard';
import type { DailyRecord } from '../../platform/records';
import type { DailyRun } from '../scene';
import { longDate } from '../kit/text';

/** `DIG #266 · 23 SEP 2026`. */
export function dayTitle(day: number, year: number, month: number, dayOfMonth: number): string {
  return `DIG #${day}  ·  ${longDate(year, month, dayOfMonth)}`;
}

/** `STONEFALL DAILY #266 ◆23 71S 9340`; a run that missed the exit says DNF instead of a time. */
export function shareLine(game: string, day: number, run: DailyRun): string {
  const core = `${game} DAILY #${day} ◆${run.diamonds}`;
  return run.won ? `${core} ${run.seconds}S ${run.score}` : `${core} DNF ${run.score}`;
}

/** The run to share: the one just played, else the day's best finished run, else none. */
export function runToShare(last: DailyRun | undefined, record: DailyRecord): DailyRun | null {
  if (last) return last;
  if (record.won) return { won: true, score: record.best, seconds: record.bestTime, diamonds: record.diamonds };
  return null;
}

/** One line of the online board, 19 characters: ` 1 ABC  12,340  71S`. */
export function boardLine(rank: number, e: BoardEntry): string {
  const score = String(Math.max(0, Math.floor(e.score))).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  const secs = `${Math.max(0, Math.floor(e.seconds))}S`;
  return `${String(rank).padStart(2)} ${e.initials.padEnd(3).slice(0, 3)} ${score.padStart(7)} ${secs.padStart(4)}`;
}
